import * as React from 'react'
import { destinationActions } from '../../domain/actions'

interface DestinationDependencies {
  googleMapsApiKey?: string
  actions?: ReturnType<typeof destinationActions>
}

const defaultDependencies: DestinationDependencies = {
  googleMapsApiKey: undefined,
}

const DestinationDependenciesContext = React.createContext<DestinationDependencies>(defaultDependencies)

export function DestinationDependenciesProvider({
  children,
  dependencies = defaultDependencies,
}: React.PropsWithChildren<{ dependencies?: DestinationDependencies }>) {
  return (
    <DestinationDependenciesContext value={dependencies}>
      {children}
    </DestinationDependenciesContext>
  )
}

export function useDestinationDependencies() {
  return React.use(DestinationDependenciesContext)
}

export function useDestinationActions() {
  const { actions } = useDestinationDependencies()
  if (!actions) {
    throw new Error('actions not provided')
  }
  return actions
}
